import FilesEvent from "@/js/Shared/Events/Entities/FilesEvent";
import EventUpload from "@/js/Shared/Events/EventUpload";

export {MeoCloudUploadItem as default};

/**
* MeoCloud Upload Item
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MeoCloudUploadItem {

  /**
   * MeoCloud Upload Events
   *
   * @public
   *
   * @type {Array}
   *
   * @since 7.0.0
   */
  events = [];

  /**
   * MeoCloud current event upload
   *
   * @public
   *
   * @type {EventUpload}
   *
   * @since 7.0.0
   */
  event;

  /**
   * MeoCloud total Files uploaded
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  current = 0;

  /**
   * MeoCloud total Files to upload
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  total = 0;

  /**
   * Defines the MeoCloud upload status
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  finished = false;

  /**
   * Creates multiple events from a given file list
   *
   * @public
   *
   * @param {FilesEvent} files file list
   *
   * @return {void}
   *
   * @since 7.0.0
   */
  createEventsFromFiles(files) {
    files.items.forEach((file) => {
      this.createEventFromFile(file);
    });
  }

  /**
   * Creates an event from a given file
   *
   * @public
   *
   * @param {File} file file
   *
   * @return {void}
   *
   * @since 7.0.0
   */
  createEventFromFile(file) {
    let event = new EventUpload();
    this.events.push(event);
    this.total++;

    event.id   = file.id;
    event.file = file;
  }
}